import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { currency } from "../helper";

const ProductCard = ({ _id, image, name, price }) => {
  return (
    <Wrapper className="product-card">
      <div className="image">
        <img src={image} alt="item" />
        <Link to={`/products/${_id}`}>
          <i className="fa-solid fa-magnifying-glass"></i>
        </Link>
      </div>

      <div className="info">
        <p className="name">{name.toLowerCase()}</p>
        <p className="price">
          {currency} {price}
        </p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  /* overflow: hidden; */
  width: 350px;

  .image {
    position: relative;
    background-color: #000;
    border-radius: 6px;
    overflow: hidden;
    height: 190px;
    > img {
      transition: var(--transition-1);
      width: 100%;
      height: 100%;
      display: block;
      position: relative;
      object-fit: cover;
    }
    > a {
      text-decoration: none;
      color: var(--color-white);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: var(--color-primary-1);
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-size: 1.2rem;
      opacity: 0;
      z-index: 10;
      transition: var(--transition-1);
    }
  }
  .image:hover {
    > img {
      opacity: 0.7;
    }
    > a {
      opacity: 1;
    }
  }

  .info {
    visibility: visible;
    margin-top: 15px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    color: var(--color-black-1);
    > .name {
      text-transform: capitalize;
    }
    > .price {
      color: var(--color-primary-1);
    }
  }
  @media screen and (max-width: 400px) {
    width: 90%;
  }
`;
export default ProductCard;
